// const { default: $ } = require("swiper/esm/utils/dom");

// GMAPS
var self = module.exports = {
    coord: {},
    map_position: null,
    pin_position: null,
    map: null,
    panorama: null,
    loaded: false,
    zoom: 16,
    image_pin: 'images/pin.svg',
    places: {
        'gastronomia': {
            status: false,
            grupos: ['bakery', 'bar', 'cafe', 'food', 'restaurant', 'meal_delivery'],
            icone: 'images/ico-places-alimentacao.svg',
            marcadores: []
        },
        'comodidade': {
            status: false,
            grupos: ['parking', 'grocery_or_supermarket', 'taxi_stand', 'supermarket', 'beauty_salon', 'bank', 'bus_station', 'car_wash', 'clothing_store', 'electronics_store', 'hardware store', 'subway_station'],
            icone: 'images/ico-places-comodidade.svg',
            marcadores: []
        },
        'educacao': {
            status: false,
            grupos: ['school', 'university', 'library', 'book_store'],
            icone: 'images/ico-places-educacao.svg',
            marcadores: []
        },
        'lazer': {
            status: false,
            grupos: ['park', 'museum', 'movie_theater', 'movie_rental', 'bowling_alley', 'art_gallery', 'aquarium', 'shopping_mall'],
            icone: 'images/ico-places-lazer.svg',
            marcadores: []
        },
        'saude': {
            status: false,
            grupos: ['hospital', 'pharmacy', 'health', 'doctor', 'dentist', 'spa', 'physiotherapist'],
            icone: 'images/ico-places-saude.svg',
            marcadores: []
        },      
    },

    init: () => {
        const coord = [-23.59691047696425, -46.65033257327247];        
        self.coord = { lat: coord[0] * 1, lng: coord[1] * 1 };

        self.addEvent('.places button', 'click', (e) => {
            e.preventDefault();
            self.load_script(e.currentTarget);
        })

        self.addEvent('.localizacao-mapa-canvas', 'mousedown', (e) => {
            self.load_script(e.currentTarget);
        })
    },


    load_script: (el_trigger) => {
        const
            sgmapsa = document.createElement('script'),
            sgmapsb = document.getElementsByTagName('script')[0];

        let
            new_el_trigger;

        sgmapsa.src = '//maps.googleapis.com/maps/api/js?key=AIzaSyDDqFAieCtHA88EFUQuDOI1A2ec28RJxlM&v=3.exp&libraries=places';

        sgmapsb.parentNode.insertBefore(sgmapsa, sgmapsb);

        sgmapsa.onload = () => {
            self.pin_position = new google.maps.LatLng(self.coord.lat, self.coord.lng);

            self.map_position = new google.maps.LatLng(self.coord.lat + .00100, self.coord.lng + .00050);

            document.querySelectorAll('.places button, .localizacao-mapa-canvas').forEach((el) => {
                const new_el = el.cloneNode(true);
                el.parentNode.replaceChild(new_el, el);

                if (el == el_trigger) new_el_trigger = new_el;
            });

            self.loaded = true;
            self.load_map(new_el_trigger);
        }

    },

    load_map: (el_trigger) => {
        const options = {
            zoom: self.zoom,
            scrollwheel: false,
            draggable: true,
            center: self.map_position,
            disableDefaultUI: true,
            zoomControl: true,
            fullscreenControl: true
        }

        var styles = [{ "stylers": [{ "saturation": -100 }] }];

        self.map = new google.maps.Map(document.querySelector(".localizacao-mapa-canvas"), options);
        self.map.setOptions({ styles: styles });

        new google.maps.Marker({
            map: self.map,
            icon: self.image_pin,
            position: self.pin_position
        });

        self.addEvent('.places button', 'click', (e) => {
            let tipo = e.currentTarget.getAttribute('data-place');
            self.load_places(tipo + '');
        });

        el_trigger.click();
    },

    load_places: (tipo) => {
        if (self.places[tipo].status) {
            self.places[tipo].status = false;

            for (let x = 0; x < self.places[tipo].marcadores.length; x++) {
                self.places[tipo].marcadores[x].setMap(null);
            }

            document.querySelector('.places button[data-place=' + tipo + ']').classList.remove('active');

        } else {
            self.places[tipo].status = true;
            const request = {
                location: self.pin_position,
                radius: 2000,
                types: self.places[tipo].grupos
            };

            const infowindow = new google.maps.InfoWindow();
            const service = new google.maps.places.PlacesService(self.map);
            service.nearbySearch(request, function (results, status) {
                if (status == google.maps.places.PlacesServiceStatus.OK) {
                    for (let i = 0; i < results.length; i++) {
                        self.places[tipo].marcadores[i] = new google.maps.Marker({
                            map: self.map,
                            position: results[i].geometry.location,
                            icon: self.places[tipo].icone,
                            name: results[i].name
                        });
                        google.maps.event.addListener(self.places[tipo].marcadores[i], 'click', () => {
                            infowindow.setContent(`<div class="info-places">${self.places[tipo].marcadores[i].name}</div>`);
                            infowindow.open(self.map, self.places[tipo].marcadores[i]);
                        });
                    }
                    document.querySelector('.places button[data-place=' + tipo + ']').classList.add('active');

                }
            });
        }
        document.querySelector('.js-places-toggle').click();
    },

    addEvent: (element, event, func) => {
        document.querySelectorAll(element).forEach((el) => el.addEventListener(event, func))
    }
}